import rng from './support/rng';
import bytesToUuid from './support/bytesToUuid';

export interface UUIDv4Options {
	random?: Uint8Array;
	rng?: () => Uint8Array;
}

/**
 * Generate a UUID v4 string (or buffer).
 *
 * @export
 * @param {UUIDv4Options} [options={}]
 * @param {Uint8Array} [buf=null]
 * @param {number} [offset=0]
 * @returns
 */
export function uuidv4(): string;
export function uuidv4(options: UUIDv4Options): string;
export function uuidv4(options: UUIDv4Options, buf: Uint8Array): Uint8Array;
export function uuidv4(options: UUIDv4Options, buf: Uint8Array, offset: number): Uint8Array;
export function uuidv4(options: UUIDv4Options = {}, buf?: Uint8Array, offset = 0): string | Uint8Array {
	const rnds = options.random || (options.rng || rng)();

	// Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	rnds[6] = (rnds[6] & 0x0f) | 0x40;
	rnds[8] = (rnds[8] & 0x3f) | 0x80;

	// Copy bytes to buffer, if provided
	if (buf) {
		for (let ii = 0; ii < 16; ++ii) {
			buf[offset + ii] = rnds[ii];
		}
	}

	return buf || bytesToUuid(rnds);
}

export default uuidv4;
